import { getSessionStorageValue } from '../utils/sessionUtils'
import dashboardIntlEn from '../multilingual/en/payees/add/dashboard_add_payees.lang.json5'
import ManualAddPayees from '../multilingual/en/payees/add/manual_add_payees.lang.json5'
import EditPayees from '../multilingual/en/payees/edit_payees.lang.json5'
import SearchPayees from '../multilingual/en/payees/search_payees.lang.json5'
import dashboardIntlEs from '../multilingual/es/payees/add/dashboard_add_payees.lang.json5'
import ManualAddPayeesEs from '../multilingual/es/payees/add/manual_add_payees.lang.json5'
import EditPayeesEs from '../multilingual/es/payees/edit_payees.lang.json5'
import SearchPayeesEs from '../multilingual/es/payees/search_payees.lang.json5'
import errorIntlEN from '../multilingual/en/payees/error.lang.json5'
import errorIntlES from '../multilingual/es/payees/error.lang.json5'
import addEditPayeeEnErrors from '../multilingual/en/payees/errors/add_edit.json5'
import addEditPayeeEsErrors from '../multilingual/es/payees/errors/add_edit.json5'
import firsttimeEn from '../multilingual/en/payees/firsttime.lang.json5'
import firsttimeEs from '../multilingual/es/payees/firsttime.lang.json5'
import findbillsEn from '../multilingual/en/payees/findbills.lang.json5'

export const useMultilingualService = (pageName) => {
  const lang = getSessionStorageValue('Language') || 'en'
  switch (pageName) {
    case 'addBillDashboard':
      return lang === 'es' ? dashboardIntlEs : dashboardIntlEn
    case 'addBillManual':
      return lang === 'es' ? ManualAddPayeesEs : ManualAddPayees
    case 'addBillSearch':
      return lang === 'es' ? SearchPayeesEs : SearchPayees
    case 'editBill':
      return lang === 'es' ? EditPayeesEs : EditPayees
    case 'error':
      return lang === 'es' ? errorIntlES : errorIntlEN
    case 'addEditErrors':
      return lang === 'es' ? addEditPayeeEsErrors : addEditPayeeEnErrors
    case 'firsttime':
      return lang === 'es' ? firsttimeEs : firsttimeEn
    case 'findbills':
      // Uncomment line below and delete next line once Spanish is made available for findBills
      // return lang === 'es' ? findbillsEs : findbillsEn
      return findbillsEn
    default:
      return ''
  }
}
export default useMultilingualService
